
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sponsor-me",
      function () {
        return require("private-next-pages/sponsor-me.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sponsor-me"])
      });
    }
  